export var ComponentType;
(function (ComponentType) {
    ComponentType["AggregateCard"] = "AggregateCard";
    ComponentType["EventCard"] = "EventCard";
    ComponentType["MiniEventCard"] = "MiniEventCard";
    ComponentType["MiniLiveOutright"] = "MiniLiveOutright";
    ComponentType["LiveOutright"] = "LiveOutright";
    ComponentType["PreliveOutright"] = "PreliveOutright";
})(ComponentType || (ComponentType = {}));
//# sourceMappingURL=ComponentType.js.map